import { API_BASE_URL } from '../../../lib/api';
import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '@/lib/tenantHeaders';

/**
 * Seguimiento de la operación LCL en curso: notas internas y recargos.
 *
 * Los headers se construyen dentro de cada función: hacerlo al importar
 * congela el token y el slug del tenant de la primera carga.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });
const BASE = () => `${API_BASE_URL}/lcl-operaciones`;

const pedir = async (url, opts = {}) => (await apiFetch(url, opts)).json();

// ---- Notas ----

export const listarNotas = (lclRequestId) =>
  pedir(`${BASE()}/by-request/${lclRequestId}/notas`, { headers: withTenant() });

export const crearNota = (lclRequestId, texto) =>
  pedir(`${BASE()}/by-request/${lclRequestId}/notas`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ texto }),
  });

export const eliminarNota = (id) =>
  pedir(`${BASE()}/notas/${id}`, { method: 'DELETE', headers: withTenant() });

// ---- Recargos ----

/** Devuelve `{ recargos, resumen }`. */
export const listarRecargos = (lclRequestId) =>
  pedir(`${BASE()}/by-request/${lclRequestId}/recargos`, { headers: withTenant() });

export const crearRecargo = (lclRequestId, payload) =>
  pedir(`${BASE()}/by-request/${lclRequestId}/recargos`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });

export const actualizarRecargo = (id, payload) =>
  pedir(`${BASE()}/recargos/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });

export const eliminarRecargo = (id) =>
  pedir(`${BASE()}/recargos/${id}`, { method: 'DELETE', headers: withTenant() });

export const urlSoporte = (id) =>
  pedir(`${BASE()}/recargos/${id}/soporte`, { headers: withTenant() });

/**
 * Sube el soporte directo a R2 con una URL firmada y devuelve lo que hay
 * que guardar en el recargo. El backend después verifica que el archivo
 * exista y esté en la carpeta de la solicitud.
 */
export async function subirSoporte(lclRequestId, file) {
  const r = await pedir(`${BASE()}/by-request/${lclRequestId}/recargos/soporte/upload-url`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({
      nombre: file.name,
      mimeType: file.type || 'application/octet-stream',
      tamano: file.size,
    }),
  });
  if (!r?.success) throw new Error(r?.message || 'No se pudo preparar la subida');

  let put;
  try {
    put = await fetch(r.data.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
      body: file,
    });
  } catch {
    // Error de red o el almacenamiento rechazó el origen (CORS del
    // bucket): `fetch` sólo dice "Failed to fetch", que no orienta.
    throw new Error(
      'No se pudo subir el archivo al almacenamiento. El recargo no se guardó: ' +
        'reintenta, o quita el adjunto para guardarlo sin soporte.',
    );
  }
  if (!put.ok) throw new Error(`No se pudo subir el archivo (${put.status})`);

  return {
    r2Key: r.data.key,
    nombreOriginal: file.name,
    mimeType: file.type || 'application/octet-stream',
    tamanoBytes: file.size,
  };
}
